export default __webpack_public_path__ + "images/59e1f8ec9db1e7daf6638de32fd69a8d.svg";